<app-publicheader></app-publicheader>

<div class="public-warper">
  <router-outlet></router-outlet>
</div>
  
<app-publicfooter></app-publicfooter>
